import _ from "lodash";
import React, { useContext } from "react";
import classes from "./CollaboratorV2SearchDropdownList.scss";
import SearchAndAddDropdown from "./components/SearchAndAddDropdown";
import SelectedCollaboratorsList from "AppComponents/CollaboratorV2/components/SelectedCollaboratorsList";
import { CollaboratorV2Context } from "AppComponents/CollaboratorV2/modules/Modules";
import { useI18n } from "Hooks";
import classNames from "classnames";
import { EmptyState } from "@toddle-edu/ds-web";
import { AddStaffIllustration } from "@toddle-edu/ds-theme";

const TEST_ID_PREFIX = "collaboratorV2-searchDropdownList";

const CollaboratorV2SearchDropdownList = props => {
  const contextValue = useContext(CollaboratorV2Context);

  const {
    searchListTypes,
    projectGroupId,
    labels,
    hideCollaborators,
    ownerId,
  } = contextValue;

  const {
    searchDropdownListSubtitle = "",
    searchDropdownListTitle = "",
    searchDropdownListSubtitleLocale = "",
  } = labels;

  const {
    selectedOptions,
    onRemoveOption,
    showListHeader,
    clickToExpand = false,
    showSearchDropdownListHeader,
    searchDropdownListContainerStyle,
    updateDoneButtonDisabled,
    testId = TEST_ID_PREFIX,
  } = props;

  const { t } = useI18n(["projectTemplate", "common"]);

  return (
    <div className={classes.container} style={searchDropdownListContainerStyle}>
      {showSearchDropdownListHeader ? (
        <div className={classes.headerContainer}>
          <span className="text-label">{t(searchDropdownListTitle)}</span>

          <span className={classNames("text-body-s", classes.subtitle)}>
            {t(searchDropdownListSubtitle, {
              label: searchDropdownListSubtitleLocale,
            })}
          </span>
        </div>
      ) : null}

      <SearchAndAddDropdown
        {...props}
        searchListTypes={searchListTypes}
        projectGroupId={projectGroupId}
        updateDoneButtonDisabled={updateDoneButtonDisabled}
        hideCollaborators={hideCollaborators}
      />

      {_.size(selectedOptions) != 0 ? (
        <SelectedCollaboratorsList
          selectedCollaborators={selectedOptions}
          onRemoveCollaborator={onRemoveOption}
          showListHeader={showListHeader}
          clickToExpand={clickToExpand}
          ownerId={ownerId}
          testId={testId}
        />
      ) : (
        <EmptyState
          illustration={AddStaffIllustration}
          size="medium"
          title={t(labels.noSelectedCollaboratorsEmptyStateText)}
          subtitle={t(labels.noSelectedCollaboratorsEmptyStateSubText)}
          dsVersion="2.0"
        />
      )}
    </div>
  );
};

export default CollaboratorV2SearchDropdownList;
